
import { createClient } from '@supabase/supabase-js'
const supabaseUrl = 'https://mmkolkkxhujhspaalgqi.supabase.co'
const supabaseKey = "sb_publishable_gec7gsqtcyORQ940_Yuhpw_Gk3N_7ki"
export const supabase = createClient(supabaseUrl, supabaseKey)